import { render, staticRenderFns } from "./type_of_work_charts.vue?vue&type=template&id=97f62e86"
import script from "./type_of_work_charts.vue?vue&type=script&lang=js"
export * from "./type_of_work_charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports